export default function NotFound() {
  return <>"PAGE NOT FOUND"</>;
}
